import React from "react";

export default function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center py-10">
      <div className="animate-spin rounded-full h-20 w-20 border-t-2 border-b-2 border-primary-500" />
    </div>
  );
}
